// Shop sensors: the calls (jobq-api "SHOP ENVIRONMENT SENSORS"). Reads take the API key only
// (beaconFetch); the admin routes carry the session's Admin PIN as X-Admin-Pin (securityFetch).
// None of them throw: each resolves {ok, status, body, message} (message = the sentence to show).

import { beaconFetch } from '../../utils/beacons';
import { securityFetch } from '../../utils/securityApi';

export { needsAdminPin } from '../../utils/securityApi';

/** GET /sensors: every sensor, its latest reading and its 24 h low / high. */
export function loadSensors() {
  return beaconFetch('/sensors');
}

/** GET /sensors/{id}/readings?hours=N: the chart's points, the window's stats and alerts. */
export function loadSensorReadings(sensorId, hours) {
  const h = Math.max(1, Math.min(2160, Math.round(Number(hours) || 24)));
  return beaconFetch(`/sensors/${encodeURIComponent(sensorId)}/readings?hours=${h}`);
}

/** POST /sensors (Admin): answers the sensor + its token, shown ONCE. */
export function createSensor(body) {
  return securityFetch('/sensors', { method: 'POST', body: JSON.stringify(body) });
}

/** PATCH /sensors/{id} (Admin): only the keys that changed; a null limit switches that side off. */
export function updateSensor(sensorId, body) {
  return securityFetch(`/sensors/${encodeURIComponent(sensorId)}`, { method: 'PATCH', body: JSON.stringify(body) });
}

/** POST /sensors/{id}/rotate_token (Admin): a new token, shown ONCE; the old one stops working. */
export function rotateSensorToken(sensorId) {
  return securityFetch(`/sensors/${encodeURIComponent(sensorId)}/rotate_token`, { method: 'POST' });
}

/** POST /sensors/{id}/test_alert (Admin): one alert through the real path ({text, texted, pushed, errors}). */
export function sendSensorTestAlert(sensorId) {
  return securityFetch(`/sensors/${encodeURIComponent(sensorId)}/test_alert`, { method: 'POST' });
}
